/* eslint-disable max-len */
import { type FinderApplicationEntrypointContextDataFragment } from '../../../../api/fragments/FinderApplicationEntrypointContextData';
import { useSingleDealerId } from '../../../../components/contexts/DealerContextManager';
import CarListingInner from './CarListingInner';
import CarListingStateProvider from './CarListingStateProvider';

export type CarListingPageProps = {
    endpoint: FinderApplicationEntrypointContextDataFragment;
};

const CarListingPage = ({ endpoint }: CarListingPageProps) => {
    const { dealerId } = useSingleDealerId();

    return (
        <CarListingStateProvider dealerIds={[dealerId]} endpoint={endpoint}>
            <CarListingInner />
        </CarListingStateProvider>
    );
};

export default CarListingPage;
